"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyScopedRoutePathEnum = exports.COMPANY_SCOPE_PREFIX = void 0;
/**
 * Prefix for company-scoped routes
 * Can be changed to "company", "c", "org", etc. without affecting functionality
 * Used to construct URLs like: /{COMPANY_SCOPE_PREFIX}/:companyId/expenses/:id
 */
exports.COMPANY_SCOPE_PREFIX = "company";
exports.CompanyScopedRoutePathEnum = {
    // expenses
    EXPENSES: `/company/:companyId/expenses`,
    EXPENSE_DETAIL: `/company/:companyId/expenses/:id`,
    FOLDER_EXPENSE_DETAIL: `/company/:companyId/expenses/:id/:childId`,
    OPOS_LIST: `/company/:companyId/opos-list`,
    // subscriptions
    SUBSCRIPTIONS: `/company/:companyId/subscriptions`,
    SUBSCRIPTION_DETAIL: `/company/:companyId/subscriptions/:id`,
    // cards
    CARDS: `/company/:companyId/credit-cards`,
    CARD_DETAIL: `/company/:companyId/credit-cards/:id`,
    WALLET_DETAIL: `/company/:companyId/credit-cards/wallet-details`,
    // transactions
    TRANSACTIONS: `/company/:companyId/transactions`,
    TRANSACTION_DETAIL: `/company/:companyId/transactions/:id`,
    // workflows
    WORKFLOWS: `/company/:companyId/workflows`,
    WORKFLOW_DETAIL: `/company/:companyId/workflows/:id`,
    // employees
    EMPLOYEES: `/company/:companyId/employees`,
    EMPLOYEE_DETAIL: `/company/:companyId/employees/:id`,
    // vendors
    VENDORS: `/company/:companyId/vendors`,
    VENDOR_DETAIL: `/company/:companyId/vendors/:id`,
    // cost centers
    COST_CENTERS: `/company/:companyId/costCenters`,
    COST_CENTER_DETAIL: `/company/:companyId/costCenters/:id`,
    // purchase orders
    PURCHASE_ORDERS: `/company/:companyId/purchase-orders`,
    PURCHASE_ORDER_DETAIL: `/company/:companyId/purchase-orders/:id`,
    // delivery notes
    DELIVERY_NOTES: `/company/:companyId/delivery-notes`,
    DELIVERY_NOTE_DETAIL: `/company/:companyId/delivery-notes/:id`,
    // LM
    LM: `/company/:companyId/liquidity`,
    LM_DASHBOARD: `/company/:companyId/liquidity/dashboard`,
    LM_CATEGORIZATION: `/company/:companyId/liquidity/categorization`,
    LM_CASHFLOW_PLANNING: `/company/:companyId/liquidity/cashflow-planning`,
    // reports
    REPORTS: `/company/:companyId/reports`,
    // settings
    SETTINGS: `/company/:companyId/settings`,
    // user settings
    SETTINGS_USER: `/company/:companyId/settings/user`,
    SETTINGS_PROFILE: `/company/:companyId/settings/user/profile`,
    SETTINGS_SECURITY: `/company/:companyId/settings/user/tools-security`,
    SETTINGS_USER_NOTIFICATIONS: `/company/:companyId/settings/user/notifications`,
    SETTINGS_USER_INTEGRATIONS: `/company/:companyId/settings/user/integrations`,
    SETTINGS_USER_ACTIVE_SESSIONS: `/company/:companyId/settings/user/active-sessions`,
    SETTINGS_USER_ABSENCE_MANAGEMENT: `/company/:companyId/settings/user/absence_management`,
    // company settings
    SETTINGS_COMPANY: `/company/:companyId/settings/company`,
    SETTINGS_FEATURE: `/company/:companyId/settings/company/feature-settings`,
    SETTINGS_COMPANY_SETTINGS: `/company/:companyId/settings/company/settings`,
    SETTINGS_BANK_ACCOUNTS: `/company/:companyId/settings/company/bank-accounts`,
    SETTINGS_EXPENSE_ACCOUNTS: `/company/:companyId/settings/company/expense-accounts`,
    SETTINGS_CC2: `/company/:companyId/settings/company/costcenter-2`,
    SETTINGS_VAT: `/company/:companyId/settings/company/vat`,
    SETTINGS_TEAMS: `/company/:companyId/settings/company/teams`,
    SETTINGS_INTEGRATIONS: `/company/:companyId/settings/company/integrations`,
    SETTINGS_EXPORT_HISTORY: `/company/:companyId/settings/company/export-history`,
    SETTINGS_NOTIFICATIONS: `/company/:companyId/settings/company/notifications`,
    // system settings
    SETTINGS_SYSTEM: `/company/:companyId/settings/system`,
    SETTINGS_COMPANIES: `/company/:companyId/settings/system/companies`,
    SETTINGS_ROLES: `/company/:companyId/settings/system/roles`,
    SETTINGS_USERS: `/company/:companyId/settings/system/users`,
    SETTINGS_SYSTEM_INTEGRATIONS: `/company/:companyId/settings/system/integrations`,
    SETTINGS_SYSTEM_Security: `/company/:companyId/settings/system/security`,
    SETTINGS_BILLING: `/company/:companyId/settings/system/billing`,
    SETTINGS_BILLING_TAB_PLAN: `/company/:companyId/settings/system/billing/plan`,
    SETTINGS_BILLING_TAB_PAYMENT_METHOD: `/company/:companyId/settings/system/billing/payment_method`,
    SETTINGS_BILLING_TAB_INVOICES: `/company/:companyId/settings/system/billing/invoices`,
    ROOT: `/company/:companyId`,
};
